import {CONFIG} from "../config";

const ApiConstants = {
  BASE_URL: CONFIG.REACT_APP_SERVER,

  //Fetches all the applications/propositions from an advisor
  PROPOSITION_CONTROLLER: '/api/propositions/',

  //Function to construct URL for creating a new application for client
  getCreateApplicationEndpoint: (saleFlowId) => `/api/saleflows/${saleFlowId}`,

  //Delete applications function to construct endpoint URL
  getClientProductDeleteEndpoint: (saleFlowId, client) => `/api/saleflows/${saleFlowId}/client/${client}`,

  //Function to construct URL for fetching client language data
  getClientLanguageEndpoint: (client, saleFlowId) => `/api/saleflows/${saleFlowId}/client-language/client/${client}`,
 
  //Function to construct URL for fetching initial product areas and subareas
  getInitialProductAreasEndpoint: (saleFlowId, client) => `/api/saleflows/${saleFlowId}/productareas/0/productsubareas/0/next/client/${client}`,

  //Function to construct URL for saving questions
  getSaveQuestionsEndpoint: (saleFlowId, areaId, subArea, client) => `/api/saleflows/${saleFlowId}/productareas/${areaId}/productsubareas/${subArea}/composition/client/${client}`,

  // Function to construct URL for fetching product areas for a client
  getProductAreasForClientEndpoint: (saleFlowId, client) => `/api/saleflows/${saleFlowId}/productareas/client/${client}`,

  // Function to construct URL for fetching composition data for a client
  getCompositionDataEndpoint: (saleFlowId, areaId, subArea, client) => `/api/saleflows/${saleFlowId}/productareas/${areaId}/productsubareas/${subArea}/composition/client/${client}`,

  // Function to construct URL for fetching child areas
  getChildAreasEndpoint: (saleFlowId, firstLevelArea, client) => `/api/saleflows/${saleFlowId}/productareas/${firstLevelArea}/childareas/client/${client}`,

  // Function to construct URL for the specific navigation endpoint
  getNavigateToAreaEndpoint: (saleFlowId, productAreaId, productSubAreaId, clientId, destinationAreaId) => `/api/saleflows/${saleFlowId}/productareaid/${productAreaId}/productsubarea/${productSubAreaId}/client/${clientId}/navigatetoarea/${destinationAreaId}`,

  // Function to construct URL for fetching next area data
  getNextAreaDataEndpoint: (saleFlowId, areaId, subArea, client) => `/api/saleflows/${saleFlowId}/productareas/${areaId}/productsubareas/${subArea}/next/client/${client}`,

  // Function to construct URL for fetching previous area data
  getPrevAreaDataEndpoint: (saleFlowId, areaId, subArea, client) => `/api/saleflows/${saleFlowId}/productareas/${areaId}/productsubareas/${subArea}/prev/client/${client}`,

  //Function to construct URL for fetching premium calculation data
  getPremiumCalculationEndpoint: (productId, client) => `/api/products/${productId}/premiumcalculation/client/${client}`,

  //Function to construct URL for getting the summary for AIS
  getAISSummary: (saleFlowId, client) => `/api/saleflows/${saleFlowId}/summary/client/${client}`,

  // Function to construct URL for getting the Main Premium on results page
  getMainPremium: (productsId, client) => `/api/products/${productsId}/monthlypremium/clientId/${client}`,

  //Function to construct URL for getting the products
  getProducts: () => `/api/saleflows/all`,

  //Function to construct URL for navigation to question
  getNavigationToQuestion: (saleFlowId, client, questionCode) => `/api/saleflows/${saleFlowId}/clientId/${client}/questionCode/${questionCode}/navigate-to-question`,

    //Function to construct URL for navigation to decision
  getNavigationToDecision: (saleFlowId, client, decisionCode) => `/api/saleflows/${saleFlowId}/clientId/${client}/decisionCode/${decisionCode}/navigate-to-decision`,

  // Function to construct URL for payment with Paysafe
  getPaymentPaysafe: (saleFlowId, productId, client) => `/api/payments/cc/saleflows/${saleFlowId}/products/${productId}/clients/${client}`,

  // Function to construct URL for getting the Bank Info for the EFT Payment
  getBankInfo: (saleFlowId, productId, client) => `/api/payments/eft/saleflows/${saleFlowId}/products/${productId}/clients/${client}/getPaymentInfo`,

  // Function to construct URL for the payer infor for the CC Payment
  getPayerInfo: (saleFlowId, productId, client) => `/api/payments/cc/saleflows/${saleFlowId}/products/${productId}/clients/${client}/getPaymentInfo`,
 
  // Function to construct URL for payment with Electronic Funds Transfer
  getPaymentEFT: (saleFlowId, productId, client) => `/api/payments/eft/saleflows/${saleFlowId}/products/${productId}/clients/${client}`,

  // Function to construct URL for getting the payable amount to display on the EFT and PaySafe payment page
  getPayableAmount: (saleFlowId, productId, client) => `/api/payments/saleflows/${saleFlowId}/products/${productId}/clients/${client}/payableAmount`,

   // Function to construct URL for getting results area for the go to results button
  getResultsArea: (saleFlowId, client) => `/api/saleflows/${saleFlowId}/clientId/${client}/navigate-to-results`,

  getSimulationInfo: () => `/api/simulations/info`,

  checkIfApplicationIsASimulation: (product, client) => `/api/simulations/check/saleflows/${product}/client/${client}`,

  // Fetch CSS design override for a saleflow (returns XML with cssValue)
  getSaleFlowDesignEndpoint: (saleFlowId) => `/api/saleflowdesign/${saleFlowId}`,

};

export default ApiConstants;